import { render, staticRenderFns } from "./QuiltyResourceCreateView.vue?vue&type=template&id=a0d2913a&"
import script from "./QuiltyResourceCreateView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0d2913a')) {
      api.createRecord('a0d2913a', component.options)
    } else {
      api.reload('a0d2913a', component.options)
    }
    module.hot.accept("./QuiltyResourceCreateView.vue?vue&type=template&id=a0d2913a&", function () {
      api.rerender('a0d2913a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/quiltyResources/QuiltyResourceCreateView.vue"
export default component.exports